import { LOADING } from "../../redux/actions/appActions";

const initialState = {
  loading: false
};

export const appReducer = (state=initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};
